import { createFileRoute } from '@tanstack/react-router';
import { LegalPage } from '../features/marketing/legal-page';
export const Route = createFileRoute('/privacy')({ component: () => <LegalPage type="privacy" /> });
